import { Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogService, DspxCardSetBaseFormComponent, FormNavigationService, SpinnerService } from 'dspx-core';
import { API_ENDPOINTS } from '../../constants/api-endpoints.constants';
import { FORM_ACTIONS, QUESTION_CODES } from '../../constants/app-data.constants';
import { ROUTE_CONSTANTS } from '../../constants/route.constants';
import { TEMPLATES } from '../../constants/templates.constants';
import { AppDataService } from '../../services/app-data.service';
import { ExcelImportService } from '../../services/excel-import.service';
import { ResponseParserService } from '../../services/response-parser.service';
import { BaseCardSetListComponent } from "../base-card-set-list-component/base-card-set-list.component";

@Component({
  selector: 'app-integrity-officer-list',
  templateUrl: './integrity-officer-list.component.html',
  styleUrl: './integrity-officer-list.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class IntegrityOfficerListComponent extends BaseCardSetListComponent implements OnInit, OnDestroy {
  @ViewChild(DspxCardSetBaseFormComponent)
  private set _baseForm(value: DspxCardSetBaseFormComponent) {
    this.baseForm = value
  }
  constructor(
    protected route: ActivatedRoute,
    protected router: Router,
    protected spinnerService: SpinnerService,
    protected dialogService: DialogService,
    protected responseParserService: ResponseParserService,
    protected appDataService: AppDataService,
    protected excelImportService: ExcelImportService,
    private formNavigationService: FormNavigationService
  ) {
    super(
      router,
      spinnerService,
      dialogService,
      responseParserService,
      appDataService,
      TEMPLATES.integrityOfficerList,
      () => API_ENDPOINTS.dashboard.getIntegrityOfficers,
      false);
  }

  ngOnInit(): void {
    this.route.url.subscribe((url) => {
      if (url.length === 0) {
        // In the case where this component is being loaded as part of the default (empty) route, we want to force it
        // to the Integrity Officer List route so that the menu will highlight the selected option.
        this.router.navigate(['/', ROUTE_CONSTANTS.integrityOfficer.list]);
       }
    });

    this.formNavigationService.onNavigation().subscribe(event => {
      setTimeout(() => {
        this.overrideHtmlTitleSetByDspxFramework();
      })
    });
  }

  ngOnDestroy(): void {
    this.unsubscribeSubscriptions();
  }

  formLoad(event: any): void {
    this.loadGridDataOnFormLoad();
  }

  filterData(event: any): void {
    // No filters are implemented in this dashboard
  }

  dialogButtonClicked(event: any): void {
    // No dialog buttons are implemented in this dashboard
  }

  actionButtonClicked(event: any): void {
    switch (event.field.key) {
      case QUESTION_CODES.integrityOfficerListForm.integrityOfficersPlaceholder: {
        switch (event.event.type) {
          case FORM_ACTIONS.integrityOfficerListForm.view:
          case FORM_ACTIONS.integrityOfficerListForm.edit: {
            this.router.navigate(['/', ROUTE_CONSTANTS.integrityOfficer.prefix, event.event.data.id]);
            break;
          }
        }
        break;
      }
    }
  }
}
